const ACTION_PREFIX = 'onboarding/main'
const SET_COMPANY_DATA = `${ACTION_PREFIX}/SET_COMPANY_DATA`
const SWITCH_AVV_STATE = `${ACTION_PREFIX}/SWITCH_AVV_STATE`
const SET_COMPANY_SIZE = `${ACTION_PREFIX}/SET_COMPANY_SIZE`
const SET_YEAR_OF_CREATION = `${ACTION_PREFIX}/SET_YEAR_OF_CREATION`
const SET_REGISTRATION_DATA = `${ACTION_PREFIX}/SET_REGISTRATION_DATA`
const SET_IS_SMALLBUSINESS = `${ACTION_PREFIX}/SET_IS_SMALLBUSINESS`
const SET_INDUSTRY = `${ACTION_PREFIX}/SET_INDUSTRY`
const SET_DEMO_TENANT = `${ACTION_PREFIX}/SET_DEMO_TENANT`
const SET_TOKEN = `${ACTION_PREFIX}/SET_TOKEN`
const SET_AVV_ALREADY_CONFIRMED = `${ACTION_PREFIX}/SET_AVV_ALREADY_CONFIRMED`
const SET_LOGO = `${ACTION_PREFIX}/SET_LOGO`
const SET_IS_SAVING = `${ACTION_PREFIX}/SET_IS_SAVING`

const initialState = {
  avvAlreadyConfirmed: false,
  token: '',
  registrationData: {
    email: '',
    password: '',
    newsletter: true,
  },
  onboardingStep: 'start',
  acceptAvv: false,
  companySize: null,
  isSubjectToImputedTaxation: true,
  isSmallBusiness: false,
  startWithDemoTenant: null,
  companyData: {
    companyName: '',
    street: '',
    zipCode: '',
    city: '',
    firstName: '',
    lastName: '',
  },
  industry: {
    group: '',
    name: '',
  },
  logo: {
    sortId: 3,
    section: 'header',
    x: null,
    y: null,
    metaData: {
      width: null,
      height: null,
    },
    file: null,
  },
  isSaving: false,
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_COMPANY_DATA: {
      const { companyData } = action
      return { ...state, companyData: { ...state.companyData, ...companyData } }
    }
    case SWITCH_AVV_STATE: {
      return { ...state, acceptAvv: !state.acceptAvv }
    }
    case SET_COMPANY_SIZE: {
      const { companySize } = action
      return { ...state, companySize }
    }
    case SET_REGISTRATION_DATA: {
      const { registrationData } = action
      return { ...state, registrationData: { ...state.registrationData, ...registrationData } }
    }
    case SET_IS_SMALLBUSINESS: {
      const { isSmallBusiness } = action
      return { ...state, isSmallBusiness }
    }
    case SET_INDUSTRY: {
      const { industry } = action
      return { ...state, industry: { ...state.industry, ...industry } }
    }
    case SET_DEMO_TENANT: {
      const { startWithDemoTenant } = action
      return { ...state, startWithDemoTenant }
    }
    case SET_TOKEN: {
      const { token } = action
      return { ...state, token }
    }
    case SET_AVV_ALREADY_CONFIRMED: {
      const { avvAlreadyConfirmed } = action
      return { ...state, avvAlreadyConfirmed }
    }
    case SET_LOGO: {
      const { logo } = action
      return { ...state, logo: { ...state.logo, ...logo } }
    }
    case SET_IS_SAVING: {
      const { isSaving } = action
      return { ...state, isSaving }
    }
    default: {
      return state
    }
  }
}

export const setCompanyData = (companyData) => ({ type: SET_COMPANY_DATA, companyData })
export const switchAvvState = () => ({ type: SWITCH_AVV_STATE })
export const setCompanySize = (companySize) => ({ type: SET_COMPANY_SIZE, companySize })
export const setYearOfCreation = (yearOfCreation) => ({ type: SET_YEAR_OF_CREATION, yearOfCreation })
export const setRegistrationData = (registrationData) => ({ type: SET_REGISTRATION_DATA, registrationData })
export const setSmallBusiness = (isSmallBusiness) => ({ type: SET_IS_SMALLBUSINESS, isSmallBusiness })
export const setIndustry = (industry) => ({ type: SET_INDUSTRY, industry })
export const setStartWithDemoTenant = (startWithDemoTenant) => ({ type: SET_DEMO_TENANT, startWithDemoTenant })
export const setToken = (token) => ({ type: SET_TOKEN, token })
export const setAvvAlreadyConfirmed = (avvAlreadyConfirmed) => ({ type: SET_AVV_ALREADY_CONFIRMED, avvAlreadyConfirmed })
export const setLogo = logo => ({ type: SET_LOGO, logo })
export const setIsSaving = (isSaving) => ({ type: SET_IS_SAVING, isSaving })
